module.exports = __webpack_public_path__ + "img/40.177a3d7.png";